import React, { useState } from "react";
import { Container } from "./styles";

const TransactionButton = ({ name, disabled }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const handleClick = () => {
    setIsOpenModal(true);
  };
  return (
    <Container onClick={handleClick} disabled={disabled}>
      {name}
    </Container>
  );
};

export default TransactionButton;
